import React, {useState} from 'react';
import {
    FluentProvider, Theme, webLightTheme,
    Dialog, DialogTrigger, DialogSurface, DialogTitle, DialogBody, DialogActions, DialogContent,
    Button,
    Textarea,
} from '@fluentui/react-components';
import BridgeMarkdown from './BridgeMarkdown';
import './Dialog.css';

interface DialogHelpProps {
    handleOnClose: ( ) => void;
}

const DialogHelp: React.FC<DialogHelpProps> = ({ handleOnClose }) => {
    const [isDialogVisible, setIsDialogVisible] = useState(true);

    const bridgeHelpTheme: Theme = {
        ...webLightTheme,
        // fontFamilyBase: "Tahoma, Geneva, sans-serif",
    };

    const closeDialog = () => {
        setIsDialogVisible(false);
        handleOnClose();
    }


    const markdown = `**Suited** is a bridge bidding brain bender. To solve it, use 
the clues to determine which player holds each cards.  
<br>
The most important clue is the auction, which hints at each
player's hand strength and suit distribution. As you guess the distribution 
of the cards, the game will reveal clues about your guesses. Hints, such as the lead card 
or additional auction insights, also may be available.  
<br>
To play, click and move cards from **Off Table** pile to a player's hand. You may transfer cards
between players or return them to the **Off Table** pile, but you cannot move your own cards - the cards 
dealt to you are fixed.  
<br>
When you think you have correctly placed *some* or *all* of the cards, you can press the **Guess** button
to evaluate your guess. If you have placed all cards correctly, you win! Otherwise, numbers next to the 
player's seat provide feedback for that seat:  
-the first number (green on white followed by a checkmark), shows the number of cards placed correctly.
-the second number (white on black, preceded by an 'R'), counts cards of the correct rank but incorrect suit.
-the third number (white on red, preceded by an 'S'), counts cards of the correct suit but incorrect rank.
`;
// <br>
// To review past guesses, click the Turn buttons below the table. When ready, click your current turn or the **Play**
// button in the center of the table.  
// <br>
// Good luck!
// ---
// There are five levels of difficulty: Beginner, Intermediate, Advanced, Life Master, and Expert 
// (World Class is not defined, yet).

// - Beginners must place all honor cards (*without tens*), get to see how many cards are in each suit, 
// and must complete the puzzle in 13 guesses.  
// - Intermediate must place all honor cards (*with tens*), get to see how many cards are in each suit,
// and must complete the puzzle in 10 guesses.  
// - Advanced must place all cards, get to see how many cards are in each suit, and must do so in 13 guesses.  
// - Life Master must place all cards, must also guess suit strength, and get 10 turns.  
// - Expert must place all cards, must also guess suit strength, and get 8 turns.  
// (World Class is not defined because they are thought to see such exercises as tedious and boring.)`;

    return (
        <FluentProvider theme={bridgeHelpTheme}>
            <Dialog
                open={isDialogVisible}
                onOpenChange={closeDialog}
            >
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle>Suited help</DialogTitle>
                        <DialogContent className='help-scrollable'>
                            {/* <BridgeMarkdown>
                                {markdown}
                            </BridgeMarkdown> */}
                            <p><strong>Suited</strong> is a bridge bidding brain bender. To solve it, use
                                the given clues to determine which player holds each cards.</p>
                            <p>The most important clue is the auction, which hints at each
                                player's hand strength and suit distribution. As you guess the distribution
                                of the cards, the game will reveal clues about your guesses. Hints, such as the lead card
                                or additional auction insights, also may be available.</p>
                            <p>When you think you have correctly placed <em>some</em> or <em>all</em> of the cards, you can press the 
                                 <strong> Guess</strong> button
                                to evaluate your guess. If you have placed all cards correctly, you win! Otherwise, numbers next to the
                                player's seat provide feedback for that seat:  </p>
                            <ul>
                                <li>the first number (green on white followed by a <span>&#10004;</span>), shows the number of cards placed correctly.</li>
                                <li>the second number (white on black, preceded by an 'R'), counts cards of the correct rank but incorrect suit.</li>
                                <li>the third number (white on red, preceded by an 'S'), counts cards of the correct suit but incorrect rank.</li>
                            </ul>
                            To review past guesses, click the Turn buttons below the table. When ready, click your current turn or the <strong>
                                Play</strong> button in the center of the table.

                            <p><strong>Good luck!</strong></p>
                            <hr />
                            <p>There are five levels of difficulty: Beginner, Intermediate, Advanced, Life Master, and Expert
                                (World Class is not defined, yet).</p>
                            <ul>
                                <li>Beginners must place all honor cards (<em>without tens</em>), get to see how many cards are in each suit, and must complete the puzzle in 13 guesses.</li>
                                <li>Intermediate must place all honor cards (<em>with tens</em>), get to see how many cards are in each suit, and must complete the puzzle in 10 guesses.</li>
                                <li>Advanced must place all cards, get to see how many cards are in each suit, and must do so in 13 guesses.</li>
                                <li>Life Master must place all cards, must also guess suit strength, and get 10 turns.</li>
                                <li>Expert must place all cards, must also guess suit strength, and get 8 turns.</li>
                            </ul>
                            <p>(World Class is not defined because they are thought to see this exercise as tedious and boring.)</p>
                        </DialogContent>
                        <DialogActions>
                            <DialogTrigger disableButtonEnhancement>
                                <Button appearance="primary">Close</Button>
                            </DialogTrigger>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </FluentProvider>
    );
};

export default DialogHelp;